module.exports = "/assets/data/1308662e3d19522008c02341d001cda8-BS30.data.json";